import * as React from 'react';
import { cn } from 'cn';
import { HoverCard as HoverCardPrimitive } from 'radix-ui';

function HoverCard({
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Root>) {
  return <HoverCardPrimitive.Root data-slot="hover-card" {...props} />;
}

function HoverCardTrigger({
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Trigger>) {
  return (
    <HoverCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />
  );
}

function HoverCardContent({
  className,
  align = 'center',
  sideOffset = 4,
  container,
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Content> & {
  container?: React.ComponentProps<
    typeof HoverCardPrimitive.Portal
  >['container'];
}) {
  return (
    <HoverCardPrimitive.Portal
      data-slot="hover-card-portal"
      container={container}
    >
      <HoverCardPrimitive.Content
        data-slot="hover-card-content"
        align={align}
        sideOffset={sideOffset}
        // Acima do componentes/dialog (11000) e do .popover do reactstrap (13000).
        // Fonte igual à do .popover legado (modern.css): 12px, line-height 1.5.
        className={cn(
          'tw:z-[200002] tw:w-64 tw:origin-(--radix-hover-card-content-transform-origin) tw:rounded-md tw:border tw:bg-popover tw:p-4 tw:text-xs tw:leading-normal tw:text-popover-foreground tw:shadow-md tw:outline-hidden tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2 tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:animate-in tw:data-[state=open]:fade-in-0 tw:data-[state=open]:zoom-in-95',
          className
        )}
        {...props}
      />
    </HoverCardPrimitive.Portal>
  );
}

export { HoverCard, HoverCardTrigger, HoverCardContent };
